import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import theme from "../../../config/theme";
import ShareIcon from "@mui/icons-material/Share";
import { BlogTypography, colData } from "../../blogs/components/Blogs";
import { useState } from "react";
import Blog1 from "../../../assets/Blog1.png";
import Blog2 from "../../../assets/Blog2.png";

const ShareButton = styled(Button)({
  height: "1.5rem",
  width: "5.4375rem",
  fontSize: "0.875rem",
  fontWeight: 600,
  letterSpacing: "0.078125rem",
  gap: "0.625rem",
});

const ShareButton1 = styled(Button)({
  height: "0.6875rem",
  width: "3.333125rem",
  fontSize: "0.5rem",
  fontWeight: 700,
  letterSpacing: "0.0532384375rem",
  gap: "0.583125rem",
});

const colData2 = [
  {
    rowData2: [
      {
        image: Blog2,
        title: "Lorem ipsum dolor sit amet, consectetur due...",
        description:
          "Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing...",
      },
      {
        image: Blog1,
        title: "Lorem ipsum dolor sit amet, consectetur due...",
        description:
          "Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing...",
      },
    ],
  },
];

const Blog = () => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = colData[0].rowData.length;

  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isMobile ? (
        <Container>
          <Box sx={{ marginTop: "2.5rem" }}>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.375rem",
                fontWeight: 700,
                letterSpacing: "0.010681125rem",
                textAlign: "center",
              }}
            >
              Blogs
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "1.375rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Avatar
              alt=""
              src=""
              sx={{
                width: "2.5rem",
                height: "2.5rem",
                backgroundColor: "#EEF6FF",
              }}
            />
            <Box sx={{ marginLeft: "0.5rem" }}>
              <Typography
                variant="h4"
                sx={{
                  color: "#212121",
                  letterSpacing: "0.0079055",
                  lineHeight: "1.25rem",
                  fontSize: "0.75rem",
                  fontWeight: 400,
                }}
              >
                Name Surname
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  color: "#212121",
                  letterSpacing: "0.0079055",
                  lineHeight: "1.25rem",
                  fontSize: "0.75rem",
                  fontWeight: 400,
                  whiteSpace: "nowrap",
                }}
              >
                DD Month YYYY | 5 min ago
              </Typography>
            </Box>
            <Box sx={{ marginLeft: "4.9375rem" }}>
              <ShareButton1>
                SHARE
                <ShareIcon
                  style={{
                    height: "1rem",
                    width: "1rem",
                  }}
                />
              </ShareButton1>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1.25rem",
            }}
          >
            <img
              src={Blog1}
              alt=""
              style={{
                width: "21.875rem",
                height: "17.25rem",
                borderRadius: "0.75rem",
              }}
            />
          </Box>
          <Typography
            variant="h4"
            sx={{
              marginTop: "1.25rem",
              color: "#212121",
              fontSize: "1rem",
              fontWeight: 700,
              letterSpacing: "0.01199775rem",
              lineHeight: "1.9375rem",
            }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit
          </Typography>
          <Typography
            variant="h4"
            sx={{
              marginTop: "1.25rem",
              color: "#212121",
              fontSize: "0.75rem",
              fontWeight: 400,
              letterSpacing: "0.0079055rem",
              lineHeight: "1.25rem",
            }}
          >
            Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing
            elit, sed do eiusmod tempor incididunt ut labore et dolore magna
            otisu Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
            do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
            enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
            ut aliquip ex ea commodo consequat. rem ipsum dolor sit amet,
            consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
            exercitation ullaiotm Ut enim ad minim veniam, quis nostruda...
          </Typography>
          <Typography
            variant="h4"
            sx={{
              marginTop: "2.5rem",
              fontSize: "1rem",
              textAlign: "center",
              fontWeight: 700,
              letterSpacing: "0.01199775rem",
            }}
          >
            Related articles
          </Typography>
          <Box sx={{ marginTop: "2.5rem", marginBottom: "1.25rem" }}>
            {colData2.map((item, index) => (
              <Box
                sx={{
                  marginBottom: "1.25rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
                key={index}
              >
                {item.rowData2.map((item, index) => (
                  <Card
                    sx={{
                      height: "14.9375rem",
                      width: "10.375rem",
                      boxShadow: "0px 8px 24px rgba(88, 101, 242, 0.15)",
                      position: "relative",
                    }}
                    key={index}
                  >
                    <CardMedia
                      component="img"
                      alt=""
                      image={item.image}
                      sx={{
                        height: "8.125rem",
                        width: "100%",
                      }}
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        transform: "translateY(-100%)",
                        flexWrap: "nowrap",
                        position: "absolute",
                        color: "#FFFFFF",
                        width: "9.375rem",
                        fontSize: "0.75rem",
                        letterSpacing: "0.0079055rem",
                        fontWeight: 700,
                        textAlign: "center",
                        lineHeight: "1.25rem",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <CardContent>
                      <Typography
                        variant="h4"
                        sx={{
                          lineHeight: "1.25rem",
                          width: "9.375rem",
                          fontSize: "0.75rem",
                          fontWeight: 400,
                          letterSpacing: "0.0079055rem",
                          color: "#212121",
                        }}
                      >
                        {item.description}
                      </Typography>
                      <Button
                        component={Link}
                        to={"/blog"}
                        style={{
                          fontSize: "0.5rem",
                          fontWeight: "700",
                          lineHeight: "0.6875rem",
                          letterSpacing: "0.0532384375rem",
                        }}
                      >
                        Read More
                      </Button>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ))}
          </Box>
        </Container>
      ) : (
        <Container>
          <Box sx={{ marginTop: "3.75rem" }}>
            <BlogTypography variant="h2">Blogs</BlogTypography>
          </Box>
          <Box
            sx={{ marginTop: "3.75rem", display: "flex", alignItems: "center" }}
          >
            <Box sx={{ flex: "1" }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "1.4375rem" }}
              >
                <Avatar
                  alt=""
                  src=""
                  sx={{
                    width: "3rem",
                    height: "3rem",
                    backgroundColor: "#EEF6FF",
                  }}
                />
                <Box sx={{ color: "#212121" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      height: "2rem",
                      width: "4.25rem",
                      fontSize: "1.5rem",
                      fontWeight: 400,
                    }}
                  >
                    Name
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      height: "1.5rem",
                      width: "16.625remrem",
                      fontSize: "1.25rem",
                      fontWeight: 400,
                      letterSpacing: "0.01rem",
                    }}
                  >
                    DD Month YYYY | 5 min ago
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                flex: "1",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <ShareButton>
                SHARE
                <ShareIcon
                  style={{
                    height: "1.25rem",
                    width: "1.25rem",
                  }}
                />
              </ShareButton>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "2.25rem",
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
              color: "#212121",
            }}
          >
            <Typography variant="h3" sx={{ fontSize: "3rem", fontWeight: 700 }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.25rem",
                color: "#212121",
                fontWeight: 400,
                letterSpacing: "0.01rem",
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna otisu Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
              minim veniam, quis nostrud exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat.
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "4rem",
              height: "40rem",
              backgroundColor: "#EEF6FF",
            }}
          ></Box>
          <Box sx={{ marginTop: "4rem" }}>
            <Typography
              variant="h4"
              sx={{
                color: "#212121",
                fontSize: "1.25rem",
                fontWeight: 400,
                letterSpacing: "0.01rem",
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna otisu Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
              minim veniam, quis nostrud exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
              labore et dolore magna aliqua. Ut enim ad minim veniam, quis
              nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat.
              <br />
              <br />
              <br />
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit
              amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna otisu Lorem ipsum dolor sit
              amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim
              veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
              ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Lorem ipsum dolor sit amet, consectetur adipiscing
              elit, sed do eiusmod tempor incididunt ut labore et dolore magna
              aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
              laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Box>
          <ShareButton sx={{ marginTop: "2.25rem" }}>
            SHARE
            <ShareIcon
              style={{
                height: "1.25rem",
                width: "1.25rem",
              }}
            />
          </ShareButton>
          <Box sx={{ marginTop: "5.25rem" }}>
            <Typography
              sx={{ fontSize: "3rem", textAlign: "center", fontWeight: 700 }}
            >
              Related articles
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "3.75rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              {colData.map((index) => (
                <Box
                  sx={{
                    marginBottom: "3.75rem",
                  }}
                  key={index}
                >
                  {[...Array(maxSteps)].map((_, i) => {
                    const step = i;
                    const item = colData[0].rowData[step];
                    return (
                      <Box
                        key={step}
                        sx={{ display: activeStep === step ? "block" : "none" }}
                      >
                        <Card
                          sx={{
                            height: "27.875rem",
                            width: "21rem",
                            boxShadow: "0px 8px 24px rgba(88, 101, 242, 0.15)",
                            position: "relative",
                          }}
                        >
                          <CardMedia
                            component="img"
                            alt=""
                            image={item.image}
                            sx={{
                              height: "16.375rem",
                              width: "21rem",
                            }}
                          />
                          <Typography
                            variant="h5"
                            sx={{
                              transform: "translateY(-100%)",
                              flexWrap: "nowrap",
                              position: "absolute",
                              color: "#FFFFFF",
                              width: "18.5rem",
                              fontSize: "1.5rem",
                              fontWeight: 400,
                              textAlign: "center",
                            }}
                          >
                            {item.title}
                          </Typography>
                          <CardContent>
                            <Typography
                              variant="h6"
                              sx={{
                                height: "6rem",
                                width: "18.625rem",
                                fontSize: "1.25rem",
                                fontWeight: 400,
                                letterSpacing: "0.01rem",
                                color: "#212121",
                              }}
                            >
                              {item.description}
                            </Typography>
                          </CardContent>
                          <CardActions>
                            <Button component={Link} to={"/blog"}>Read More</Button>
                          </CardActions>
                        </Card>
                      </Box>
                    );
                  })}
                </Box>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {[...Array(maxSteps)].map((_, step) => (
                <Box
                  key={step}
                  sx={{
                    width: "1.125rem",
                    height: "1.125rem",
                    bgcolor: activeStep === step ? "#585fe2" : "#bdbdbd",
                    borderRadius: "50%",
                    margin: "0.5rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleStepChange(step)}
                />
              ))}
            </Box>
          </Box>
        </Container>
      )}
    </ThemeProvider>
  );
};

export default Blog;
